import { Vehicle } from 'further-types/lp/vehicle';
import { VehicleApplication } from '../types';
import CommitmentPreview from './CommitmentPreview';
import CommitmentSettings from './CommitmentSettings';
import ErrorBoundary from 'components/ErrorBoundary';

type Props = {
  title?: string;
  application: VehicleApplication;
  vehicle: Vehicle;
  onCommitmentComplete: () => void;
  isInvestorJourneyForm?: boolean;
};

const CommitmentDetails: React.FC<Props> = ({
  title = 'Commitment details',
  application,
  vehicle,
  onCommitmentComplete,
  isInvestorJourneyForm = false,
}) => {
  return (
    <ErrorBoundary>
      {application.commitment ? (
        <CommitmentPreview
          title={title}
          commitment={application.commitment}
          investorLocalCurrency={application.investorLocalCurrency}
          vehicle={vehicle}
        />
      ) : application.commitmentSettings.isManuallyAddedCommitment ||
        isInvestorJourneyForm ? (
        <CommitmentSettings
          title={title}
          application={application}
          vehicle={vehicle}
          onCommitmentComplete={onCommitmentComplete}
          fullWidth={isInvestorJourneyForm}
        />
      ) : null}
    </ErrorBoundary>
  );
};

export default CommitmentDetails;
